<template>
  <div class="tile is-parent is-vertical">
    <p class="formtitle">Minhas Redações >> {{formtitle}}</p>

    <article class="tile is-child is-12 notification formbox">
      <form @submit.prevent="validate">
        <b-notification
          class="updateFormFeed"
          v-if="redacao.feedback != null"
          type="is-warning"
          has-icon
          aria-close-label="Close notification"
          role="alert"
        >
          <strong>Feedback:</strong>
          {{redacao.feedback}}
        </b-notification>
        <b-field
          label="Selecione a Proposta"
          class="select-proposta"
          :type="{'is-danger': errors.has('proposta')}"
          :message="errors.first('proposta')"
        >
          <b-select
            placeholder="Selecione a Proposta:"
            icon="file-document"
            expanded
            v-model="redacao.proposta_id"
            name="proposta"
            v-validate="'required'"
          >
          
            <optgroup v-for="grade in grades" :key="getGradeKey(grade)" :label="getGradeKey(grade)">
              <option
                v-for="proposta in getProposta(grade)" 
                :key="proposta.id"
                :value="proposta.id"
              >{{proposta.nome}}</option>
            </optgroup>
            
          </b-select>
        </b-field>

        <b-field class="uploadlabel redacao.file" label="Selecione o arquivo de sua redação">
          <b-upload v-model="redacao.file" accept="image/x-png, image/png, image/jpg, image/jpeg">
            <a class="button uploadbutton">
              <span class="icon-subir-redacao"></span>
              <span>Selecionar arquivo</span>
            </a>
          </b-upload>
          <span class="file-name" v-if="redacao.file">{{ redacao.file.name }}</span>
        </b-field>

        <div class="uploadtext">
          <strong>formatos permitidos:</strong> png, jpg, jpeg
        </div>

        <b-field
          hidden
          label="id"
          :type="{'is-danger': errors.has('id')}"
          :message="errors.first('id')"
        >
          <b-input v-model="redacao.aluno_id" v-validate="'required'" name="id" disabled></b-input>
        </b-field>

        <b-button
          native-type="submit"
          @click="clicked = true"
          class="button form-submit rigth btnNewR"
          :loading="clicked"
        >{{buttom}}</b-button>
      </form>
    </article>
  </div>
</template>
<script>
import PropostaService from "@/services/PropostaService";

/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
export default {
  data() {
    return {
      grades: [],
      clicked: false
    };
  },
  name: "redacaoForm",
  props: ["redacao", "buttom", "formtitle"],
  methods: {
    validate() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;

          this.$emit("formSubmit", self.redacao, () => {});
        }
      });
    },
    createPropostasOptions() {
      return "";
    },
    getGradeKey(grade){
      return Object.keys(grade)[0];
    },
    getProposta(grade){
      console.log("grade");
      console.log(grade);
      console.log("get grade");
      console.log(grade[Object.keys(grade)[0]]);
      //key -> alert(Object.keys(grade)[0]);
      //alert(grade[Object.keys(grade)[0]][0].nome);
      return grade[Object.keys(grade)[0]];
    }
  },
  components: {},
  created() {
    PropostaService.PerGrade(this.$store.getters.cargo, this.$store.getters.cargo_id).then(result => {
      this.grades = result;
      //alert(Object.keys(this.grades[0])[0])
    });
  }
};
</script>
<style lang="scss" scoped>
.uploadlabel {
  margin-left: 50px;
}
</style>